import { Row, Col, Container, Nav, Navbar } from 'react-bootstrap';
import { useEffect, useState, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom'
// import { useUser } from '../../../hooks/auth';
import classNames from 'classnames';

// component
import Menu from './Menu';
import NotificationDropdown from './NotificationDropdown';
import ProfileDropdown from './ProfileDropdown';
import {
  businessLogoSimple,
  standardLogo,
  bloghouseLogoSmall
} from '../../../assets/images'

// utilities
import { 
  authContextHelper, 
  types
} from 'utilities';
import { useOpenConfig } from 'utilities/variables/openConfigContext';

type TopNavProps = {
    isSticky?: boolean;
    navClass?: string;
    fixedWidth?: boolean;
    showTopSearchBar: boolean;
};

const Topnav: React.FC<TopNavProps> = ({ isSticky, navClass, fixedWidth, showTopSearchBar }: TopNavProps) => {
  const { config } = useOpenConfig();
  const authContext = useContext(authContextHelper.AuthContext);
  const isSignedIn = authContext.authStatus === authContextHelper.AuthStatus.SignedIn;
  const [notificationsSorted, setNotificationsSorted] = useState<any>([]);
  const [isNewNotifications, setIsNewNotifications] = useState<boolean>(true);
  const [userAttributes, setUserAttributes] = useState<types.IAccountUserAttributes | null>({
    ...authContext.userProfile['attributes'],
    role: authContext.userProfile['role']
  });

  const location = useLocation();
  

  const handleSignOut = async (event: React.MouseEvent) => {
    event.preventDefault();
    authContext.signOut();
  }

  /* eslint-enable react-hooks/exhaustive-deps */

  // on scroll add navbar class
  useEffect(() => {
    const btnTop = document.getElementById('btn-back-to-top');

    const onScroll = () => {
      if (!btnTop) return;
      const scrolled =
        document.body.scrollTop >= 50 || document.documentElement.scrollTop >= 50;
      btnTop.classList.toggle('show', scrolled);
    };

    window.addEventListener('scroll', onScroll);
    onScroll(); // initialise

    // Keep user attributes in sync when profile changes
    setUserAttributes((_prev) => ({
      ...authContext.userProfile?.attributes,
      role: authContext.userProfile?.role,
    }));

    attachWebSocket();

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
    // Attach once; separately watch profile if you want finer control
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setUserAttributes(
      authContext.userProfile
        ? {
          ...authContext.userProfile.attributes,
          role: authContext.userProfile.role,
        }
        : null
    );
  }, [authContext.userProfile]);


  authContext.getAmplifyCurrentAthenticatedUser
  
  const attachWebSocket = () => {
    // TODO: implement behaviour
  }


  const clearNotifications = () => {
    setNotificationsSorted([])
  }


  return (
    <>
      {location.pathname === '/product-window'? 
        null
        :
        <div id="k-app-header" className="k-header-height">
          <header>
            <Navbar
              id={isSticky ? 'sticky' : ''}
              collapseOnSelect
              expand="lg"
              className={classNames('topnav-menu navbar-sticky', navClass)}
            >
              <Container fluid={!fixedWidth}>
                {/*
                      <Navbar.Brand href="/" className="logo">
                          <img src={logo} height="30" className="align-top logo-dark" alt="" />
                          <img src={logoLight} height="30" className="align-top logo-light" alt="" />
                      </Navbar.Brand>
                      */}

                <Navbar.Toggle className="me-3" aria-controls="topnav-menu-content4" />

                <Navbar.Collapse id="topnav-menu-content4">
                  <Menu />
                          
                  <Nav as="ul" className="navbar-sections align-items-lg-center">
                    <div className='pt-2 ps-2'> {/* This is the left section */}
                      {/*<img className='k-mh-30' src={businessLogo}></img>*/}
                      {
                        showTopSearchBar ? (
                          location.pathname !== '/' ? (
                            <Link to="/">
                              {config ? (
                                config.BRANDING === 'GENERIC' ? (
                                  <img className="ms-2 k-mh-40" src={standardLogo} alt="Standard Logo"></img>
                                ) : config.BRANDING === 'KURO' ? (
                                  <img className="ms-2 k-mh-40" src={businessLogoSimple} alt="Kuro Logo"></img>
                                ) : (
                                  <img className="ms-2 k-mh-30" src={bloghouseLogoSmall} alt="Bloghouse Logo"></img>
                                )
                              ) : null}
                            </Link>
                          ) : (
                            <></>
                          )
                        ) : (
                          <></>
                        )
                      }
                    </div> 
                    <div className="nav-item"> {/* This is the middle section */}
                              
                                  
                    </div>
                    { isSignedIn ?   
                      <div className="align-items-lg-center"> {/* This is the right section */}
                        <Row className='m-0 p-0'> 
                          <Col className='m-1 p-0'>
                            {/*<Button onClick={triggerWebSocketPayload}>Sock-Trig</Button>*/}
                          </Col>

                          <Col className='m-0 p-0'>
                            <NotificationDropdown 
                              notifications={notificationsSorted} 
                              isNewNotifications={isNewNotifications}
                              setIsNewNotifications={setIsNewNotifications}
                              clearNotifications={clearNotifications}
                            />
                          </Col>
                          
                          <Col className='m-0 p-0'>
                            {userAttributes &&
                          <ProfileDropdown 
                            userAttributes={userAttributes} 
                            handleSignOut={handleSignOut}
                          />}
                          </Col>

                        </Row>
                      </div>
                      :
                      <></>
                    }
                  </Nav>
                </Navbar.Collapse>
              </Container>
            </Navbar>
          </header>
        </div>
      }
    </>
    
  );
};

export default Topnav;
